<template>
    <div class="tabs" :class="class_names">
      <ul class="nav nav-tabs" :id="tabs_id" role="tablist">
        <li class="nav-item" v-for="(name, key) in tabs" :key="`tab-${tabs_id}-${key}`">
          <a class="nav-link"
             :class="{active: key === selected}"
             :id="`tab-${tabs_id}-${key}`"
             :href="`#tab-content-${tabs_id}-${key}`"
             role="tab"
             :aria-controls="`#tab-content-${tabs_id}-${key}`"
             :aria-selected="'true'"
             @click.prevent="selected = key">
            <slot :name="`tab-${name}`">{{ typeof name === 'object' ? name.name : name }}</slot>
          </a>
        </li>
      </ul>
      <div class="pre-tab-content">
        <slot name="pre-tab-content"></slot>
      </div>
      <div class="tab-content" :id="`tab-content-${tabs_id}`">
        <div  v-for="(name, key) in tabs" :key="`tab-${tabs_id}-${key}`"
              class="tab-pane fade"
              :class="{'show active': key === selected}"
              :id="`#tab-content-${tabs_id}-${key}`"
              role="tabpanel"
              :aria-labelledby="`tab-${tabs_id}-${key}`">
          <slot :name="`tab-content-${key}`">Default Tab Content for {{ typeof name === 'object' ? name.name : name }}</slot>
        </div>
      </div>
    </div>
</template>

<script>
import utils from "@/mixins/utils";

export default {
    name: "Tabs",
    emits: ['change'],
    props: {
        tabs: {
            type: [Object, Array],
            default: {},
        },
        tabSize: {
            type: String,
            default: 'md',
        }
    },
    mixins: [utils],

    data(){
      return {
          selected: -1,
      }
    },

    watch: {
      selected(value){
        this.$emit('change', value);
      }
    },

    computed: {
        tabs_id(){
            return this.utils.randomId({prefix: 'tab'});
        },
        class_names(){
          return [
              'active-' + this.selected,
              'tab-size-' + this.tabSize,
          ];
        }
    },

    beforeMount() {
        if( Array.isArray( this.tabs ) ){
            this.selected = this.tabs.length > 0 ? 0 : -1;
        }else{
            const keys = Object.keys( this.tabs );
            this.selected = keys.length > 0 ? keys[0] : -1
        }
    }

}
</script>

<style lang="scss" scoped>
.nav{
    padding: 0 1rem;
}

.tab-size-lg{
    .nav-tabs{
        .nav-link{
            font-size: 1rem;
            padding: 0.4rem 0.8rem;
        }
    }
}

</style>
